












import {Component, Vue} from 'vue-property-decorator';
import Error from '@/components/views/Error.vue';
import Loading from '@/components/layout/Loading.vue';
import {SET_DATA, SET_LANGUAGE, SET_TOKEN, SET_DEBUG} from "@/store";
import {SET_LAYOUT_CONFIG} from "@/store/layout_module";
import {Route} from "vue-router";
import i18n, {loadLanguageAsync} from "@/i18n";
import GlobalMixin from "@/mixins";

@Component({
    components: {
        Loading,
        Error
    },
    beforeRouteEnter(to: Route, from: any, next: any) {
        const token = to.params.token;
        const debug = to.query.debug !== undefined;
        const noTracking = to.query.notracking !== undefined || !!Vue.cookies.get('PROMPT_TRACKING_DISABLED');
        next((d: Dashboard) => {
            d.fetchData(token, debug, noTracking);
        });
    }
})
export default class Dashboard extends GlobalMixin {

    private loading: boolean = true;
    private error: boolean = false;

    private fetchData(token: string, debug: boolean = false, noTracking: boolean = false) {
        this.loading = true;
        this.$store.commit('layout/' + SET_LAYOUT_CONFIG, {
            showPageTitle: false,
            showFooterNav: false
        });

        let params = {
            id: token
        }
        if (debug) {
            params = Object.assign(params, {
                debug: 1
            });
        }
        if (noTracking) {
          params = Object.assign(params, {
            noTracking: 1
          });
        }

        this.$store.commit(SET_DEBUG, debug);

        this.$store.commit(SET_TOKEN, token);
        this.axios.get(process.env.VUE_APP_API_URL + '', {
            params
        }).then(response => {
            this.loading = false;


            this.$store.commit('layout/' + SET_LAYOUT_CONFIG, {
                showPageTitle: this.$route.meta.pageTitleConfig.showPageTitle,
                showFooterNav: this.$route.meta.pageTitleConfig.showFooterNav,
            });

            this.$store.commit(SET_DATA, response.data.data);

            this.$store.commit(SET_LANGUAGE, response.data.data.base_info.lang);

            loadLanguageAsync(response.data.data.base_info.lang);

            if (response.data && response.data.data && response.data.data.goals && response.data.data.goals.length) {
              this.track('Open Dashboard - Current Goal', response.data.data.goals[0].goalKey, token);
            }

        }).catch((error) => {
            this.loading = false;
            this.error = true;
        });
    }


}
